import {BsLinkedin,BsGithub} from 'react-icons/bs'
import { SiLeetcode ,SiGeeksforgeeks} from "react-icons/si";

export const socialLinks = [
    {
        id: 1,
        icon : <BsLinkedin />,
        url : 'https://www.linkedin.com/in/mohammed-adhil-ashraf-6a29611b0/'
    },
    {
        id: 2,
        icon : <BsGithub />,
        url : 'https://github.com/adhil-bit'
    },
    {
        id: 3,
        icon : <SiLeetcode />,
        url : 'https://leetcode.com/adhil-bit/'
    },
    {
        id: 4,
        icon : <SiGeeksforgeeks />,
        url : 'https://auth.geeksforgeeks.org/user/adhil-bit/profile'
    },
    
]